import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { filter } from 'rxjs/operators';
import { loginAndGetDashboardResponse } from '../models/login-authentication-screen.interface';
import { AddLoginInfoAdapterRedirectService } from './add-login-info-adapter-redirect.service';
@Injectable({
  providedIn: 'root'
})
export class PingLoginAdapterHelperService extends AddLoginInfoAdapterRedirectService {
  processBusinessUserLogic(
    response: loginAndGetDashboardResponse,
    corpCookie: string | null,
    isHipmunk: string | false | null,
    authenticationConfig?: OauthAEMConfig,
    standalonePage = false,
    tokenResponse?: string
  ) {
    let restrictLoginPicker = false;
    if (
      this.loginAuthenticationHelperService.disableBizLoginResponseCheck(
        response,
        corpCookie
      )
    ) {
      restrictLoginPicker =
        this.loginAuthenticationHelperService.checkForLoginPickerRestrictedPageList(
          standalonePage
        );
      const fromAdmin = this.loginUtilHelperService.fromAdmin$.value;
      const cookieNameForPicker =
        this.loginAuthenticationHelperService.restrictLoginPickerIsHipmunkCheck(
          restrictLoginPicker,
          isHipmunk,
          fromAdmin
        );
      this.coreUtilService.setCookieName(
        'accountType',
        cookieNameForPicker,
        0,
        true,
        authenticationConfig
      );
      this.redirectionLogicForBusinessUser(
        restrictLoginPicker,
        isHipmunk,
        response,
        authenticationConfig,
        standalonePage,
        fromAdmin,
        tokenResponse
      );
    }
  }

  nuTravelStartSlo(authenticationConfig: OauthAEMConfig) {
    let nuTravelUrl = [];
    if (this.loginUtilHelperService.getRefreshURLParams().fromAdmin) {
      return;
    }
    if (authenticationConfig.NU_TRAVEL_URL) {
      nuTravelUrl = authenticationConfig.NU_TRAVEL_URL;
      if (nuTravelUrl?.indexOf(document.referrer) !== -1) {
        this.logOutService.logOut();
        //TODO: remove this later: this.makeStartSloCall(authenticationConfig);
      }
    }
  }

  makeStartSloCall(authenticationConfig: OauthAEMConfig) {
    const encryptedTokenStored = this.coreUtilService.get('encyToken');
    const uniqueIdentifierStored = this.coreUtilService.get('uid');
    if (encryptedTokenStored || uniqueIdentifierStored) {
      this.coreUtilService.remove('encyToken');
      this.coreUtilService.remove('uid');
    }
    if (authenticationConfig.ENABLE_NEW_PERSISTENT_LOGIN) {
      this.coreUtilService.sendMessage({ type: 'DELETE_TOKEN' });
      this.coreUtilService.sendMessage({ type: 'DELETE_STATUS' });
    }
    const pingLogoutUrl = `${authenticationConfig.PING_DOMAIN}${authenticationConfig.LOG_OUT_URL}${window.location.href}`;
    return this.nuTravelSkyBonusUtilService.redirectUserToRefreshUrl(
      this.fromApplication,
      this.redirectUrl,
      pingLogoutUrl,
      authenticationConfig
    );
  }

  processRedirectionLogic(
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig,
    standalonePage = false,
    tokenResponse?: string
  ) {
    const corpCookie: string | null = this.cookieHelper.getCookieValue('corp');
    this.coreUtilService.setCookieName(
      'account',
      '',
      0,
      false,
      authenticationConfig
    );
    const isHipmunk = this.cookieHelper.getCookieValue('isHipmunk')
      ? this.cookieHelper.getCookieValue('isHipmunk')
      : false;
    const cookieNameForPicker = '';
    this.assignRedirectUrl(authenticationConfig);
    if (this.checkRefreshUrlFromDashBrdResponse(response)) {
      response.refreshURL = this.queryParamRefreshUrl;
    }
    if (response?.isBusiness) {
      this.processBusinessUserLogic(
        response,
        corpCookie,
        isHipmunk,
        authenticationConfig,
        standalonePage,
        tokenResponse
      );
    } else {
      this.processRedirectionLogicHelper(
        cookieNameForPicker,
        corpCookie,
        isHipmunk,
        response,
        authenticationConfig,
        standalonePage,
        tokenResponse
      );
    }
  }

  checkRefreshUrlFromDashBrdResponse(response: loginAndGetDashboardResponse) {
    return response?.refreshURL && this.redirectRefreshUrlCheck;
  }

  assignRedirectUrl(authenticationConfig?: OauthAEMConfig) {
    this.route.queryParams
      .pipe(filter((params) => params.refreshURL))
      .subscribe((params) => {
        this.queryParamRefreshUrl = decodeURIComponent(params.refreshURL);
        if (this.queryParamRefreshUrl) {
          this.checkForRedirectUrl(
            this.queryParamRefreshUrl,
            authenticationConfig
          );
        }
      });
  }
}
